'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPubSubMessage = undefined;

var _getters = require('./getters');

/**
 * Returns either the message passed in directly to this function or
 * the `message` field on the argument. This is intended to be used
 * when dealing with messages that are either themselves pubsub messages
 * or wrappers around pubsub messages (e.g. ActivelyPublishing, FailedToPublish)
 *
 * @param {Record} pubSubOrUnpublishedMessage - the message
 * @returns {Record} - a pubSub message (e.g. CommonMessage, PubNubMessage)
 */
var getPubSubMessage = exports.getPubSubMessage = function getPubSubMessage(pubSubOrUnpublishedMessage) {
  return (0, _getters.getMessage)(pubSubOrUnpublishedMessage) || pubSubOrUnpublishedMessage;
};